module.exports = __webpack_public_path__ + "static/media/delivery_boy.03ffd4ec.png";